"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentSchedule = void 0;
const UserCommitment_1 = require("./UserCommitment");
class PaymentSchedule extends UserCommitment_1.UserCommitment {
  commitmentHistory;
  headers;
  headersLabels;
  returnKeys;
  configuration;
  constructor(_ref) {
    let {
      commitment,
      commitmentHistory,
      headers,
      configuration
    } = _ref;
    super({
      commitment
    });
    this.commitment = commitment;
    this.commitmentHistory = commitmentHistory;
    this.headers = headers;
    this.headersLabels = headers?.map(item => item.label) || [];
    this.returnKeys = headers?.map(item => item.key) || [];
    this.configuration = configuration;
    this.toCurrency = this.toCurrency.bind(this);
  }
  sortListItems(items) {
    return items.sort((a, b) => {
      const aDate = this.getTime(a.dueDate || "0");
      const bDate = this.getTime(b.dueDate || "0");
      return aDate - bDate;
    });
  }
  mapPaymentToTxnListItem(_ref2) {
    let {
      dataType = "status",
      status,
      payment,
      headers,
      returnKeys,
      updateNote
    } = _ref2;
    const returnObj = {
      dataType,
      headers,
      update: updateNote,
      currency: this.currency
    };
    returnKeys?.forEach(key => {
      switch (key) {
        case "description":
          if (this.configuration?.useInstalmentSeq) {
            returnObj[key] = payment?.instalmentSeq?.toString() || "Bank Transfer";
          } else {
            returnObj[key] = payment?.instalmentPlan?.id ? "Monthly Instalment" : "One-Off Payment";
          }
          break;
        case "amountDue":
          returnObj[key] = payment?.amountDue;
          break;
        case "dueDate":
          returnObj[key] = payment?.dueAt;
          break;
        case "amountPaid":
          returnObj[key] = payment?.amountPaid;
          break;
        case "paidDate":
          returnObj[key] = payment?.paidAt;
          break;
        case "txnStatus":
          returnObj[key] = status;
          break;
      }
    });
    return returnObj;
  }
  get historicalUpdates() {
    const noItem = !this.commitmentHistory.length;
    if (noItem || this.commitmentHistory.length < 2) return [];
    return this.commitmentHistory.reduce((updates, curr, idx) => {
      const nextItem = this.commitmentHistory[idx + 1];
      const shouldStore = nextItem && nextItem.amount !== curr.amount;
      if (shouldStore) {
        const commitmentUpdateText = `Investment commitment updated from ${this.toCurrency(curr.amount)} to ${this.toCurrency(nextItem.amount)} on ${new Date(nextItem.created_at).toDateString()}`;
        updates.push({
          created_at: nextItem.created_at,
          note: commitmentUpdateText
        });
      }
      return updates;
    }, []);
  }
  get transactionList() {
    const {
      instalmentPaymentSet,
      oneOffPaymentSet,
      instalmentData,
      oneOffData
    } = this.commitment;
    const paymentsConfirmed = [...instalmentPaymentSet.paymentsConfirmed, ...oneOffPaymentSet.paymentsConfirmed];
    const paymentsDue = [...instalmentPaymentSet.paymentsDue, ...(oneOffPaymentSet.paymentDue ? [oneOffPaymentSet.paymentDue] : [])];
    const paymentsUpcoming = instalmentPaymentSet.paymentsPending;
    const paymentsCancelled = [...(oneOffData?.paymentsCancelled || []), ...(instalmentData?.paymentsCancelled || [])];
    const mapPayments = (payments, status) => payments.map(item => this.mapPaymentToTxnListItem({
      dataType: "status",
      headers: this.headers,
      returnKeys: this.returnKeys,
      payment: {
        ...item
      },
      status: status
    }));
    const confirmedList = mapPayments(paymentsConfirmed, "CONFIRMED");
    const dueList = mapPayments(paymentsDue, "DUE NOW");
    const upcomingList = mapPayments(paymentsUpcoming, "UPCOMING");
    const cancelledList = mapPayments(paymentsCancelled, "CANCELLED");
    const formattedUpdates = this.historicalUpdates?.map(updateNote => this.mapPaymentToTxnListItem({
      dataType: "update",
      updateNote: updateNote.note
    }));
    const paymentsList = [...confirmedList, ...cancelledList, ...dueList, ...upcomingList];
    for (let i = 0; i < formattedUpdates.length; i++) {
      const pListItemIndex = paymentsList.findIndex(item => this.getTime(item.dueDate || "0") > this.getTime(this.historicalUpdates[i].created_at));
      paymentsList.splice(pListItemIndex, 0, formattedUpdates[i]);
    }
    return {
      data: this.sortListItems(paymentsList),
      headers: this.headers
    };
  }
  get shouldRenderChildren() {
    return !!this.transactionList.data.length;
  }
  get data() {
    return {
      totalCommitment: this.totalCommitment,
      totalTransferred: this.totalTransferred,
      instalmentPlan: this.instalmentPlan,
      instalmentBreakdown: this.instalmentBreakdown,
      shouldRenderChildren: this.shouldRenderChildren,
      transactionList: this.transactionList,
      commitmentId: this.commitment.id,
      dealId: this.commitment.dealId,
      instalmentPlanProgress: this.instalmentPlanProgress,
      nextDue: this.nextDue,
      currency: this.currency,
      instalmentPlanStatus: this.commitment.instalmentData?.status
    };
  }
}
exports.PaymentSchedule = PaymentSchedule;